import Layout from 'features/shared/Layout';
import ProPage from 'features/pages/Pro';

export default function Pro() {
  return (
    <Layout
      description="Become a Pro member and gain access to our premium challenges and design files."
      image="https://res.cloudinary.com/dz209s6jk/image/upload/v1585172856/Meta/meta-homepage.png"
      title="Frontend Mentor | Pro subscriptions"
      url="https://www.frontendmentor.io/pro"
    >
      <ProPage />
    </Layout>
  );
}

export async function getStaticProps() {
  return { props: {} };
}
